import styled from "styled-components";
import { fade } from "@material-ui/core/styles";
import {
  cuideoTheme,
  COLOR_BORDER,
  COLOR_BORDER_LIGHT,
  COLOR_ERROR_HOVER,
  COLOR_SURFACE_SOFT,
  COLOR_SURFACE_SOFT_HOVER,
  COLOR_TEXT_MUTED,
} from "../../../../containers/themes/defaultTheme";

export const MobileList = styled.div`
  font-family: "Source Sans Pro", Helvetica, Arial, sans-serif;
  width: 100%;
  overflow: hidden;
`;

export const MobileDayBox = styled.div`
  border: 1px solid ${COLOR_BORDER};
  border-radius: 5px;
  overflow: hidden;
  background: #fff;
  & + & {
    margin-top: 8px;
  }
`;

export const MobileDayRow = styled.div<{
  $disabled: boolean;
  $clickable?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 0.5rem 1rem;
  border-bottom: 1px solid ${COLOR_BORDER_LIGHT};
  opacity: ${({ $disabled }) => ($disabled ? 0.4 : 1)};
  background: ${COLOR_SURFACE_SOFT};
  cursor: ${({ $clickable }) => ($clickable ? "pointer" : "default")};
  &:hover {
    background: ${({ $clickable }) =>
      $clickable ? COLOR_SURFACE_SOFT_HOVER : COLOR_SURFACE_SOFT};
  }
`;

export const MobileDayLabel = styled.span`
  font-size: 0.95rem;
  font-weight: 600;
  color: ${cuideoTheme.palette.primary.main};
`;

export const MobileEventRow = styled.div<{ $clickable?: boolean }>`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0.4rem 1rem 0.4rem 0.5rem;
  border-bottom: 1px solid ${COLOR_BORDER_LIGHT};
  cursor: ${({ $clickable }) => ($clickable ? "pointer" : "default")};
  &:hover {
    background: ${({ $clickable }) =>
      $clickable ? COLOR_SURFACE_SOFT : "transparent"};
  }
`;

export const MobileEventTime = styled.span`
  flex: 1;
  font-size: 0.85rem;
  color: ${cuideoTheme.palette.primary.main};
`;

export const TimeSelectGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: 0.85rem;
  color: ${cuideoTheme.palette.primary.main};
`;

export const TimeSelect = styled.select`
  font-family: "Source Sans Pro", Helvetica, Arial, sans-serif;
  font-size: 0.85rem;
  color: ${cuideoTheme.palette.primary.main};
  border: 1px solid ${COLOR_BORDER};
  border-radius: 4px;
  padding: 4px 2px;
  background: #fff;
  outline: none;
  &:focus { border-color: ${cuideoTheme.palette.secondary.main}; }
`;

export const TimeSeparator = styled.span`
  font-size: 0.85rem;
  color: ${cuideoTheme.palette.primary.main};
  padding: 0 4px;
`;

export const MobileDeleteButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: ${cuideoTheme.palette.error.main};
  color: #fff;
  cursor: pointer;
  flex-shrink: 0;
  margin-left: auto;
  &:hover { background: ${COLOR_ERROR_HOVER}; }
`;

export const MobileHint = styled.p`
  margin: 0;
  padding: 0.45rem 1rem;
  font-size: 0.8rem;
  font-style: italic;
  color: ${COLOR_TEXT_MUTED};
`;

export const AddEventButton = styled.div`
  margin: 0.4rem 1rem;
  padding: 0.4rem 1rem;
  font-size: 0.8rem;
  color: ${cuideoTheme.palette.secondary.main};
  border: 1px solid ${cuideoTheme.palette.secondary.main};
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  text-align: center;
  &:hover { background: ${fade(cuideoTheme.palette.secondary.main, 0.1)}; }
`;

export const MobileCopyButton = styled.button<{ $disabled: boolean }>`
  display: flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: 1px solid ${({ $disabled }) => ($disabled ? COLOR_BORDER : cuideoTheme.palette.primary.main)};
  border-radius: 4px;
  color: ${({ $disabled }) => ($disabled ? COLOR_BORDER : cuideoTheme.palette.primary.main)};
  font-family: "Source Sans Pro", Helvetica, Arial, sans-serif;
  font-size: 0.7rem;
  font-weight: 600;
  cursor: ${({ $disabled }) => ($disabled ? "default" : "pointer")};
  padding: 2px 8px;
  pointer-events: ${({ $disabled }) => ($disabled ? "none" : "auto")};
  &:hover {
    background: ${({ $disabled }) =>
      $disabled ? "none" : fade(cuideoTheme.palette.primary.main, 0.08)};
  }
`;
